import { downloadImage, isMainland } from '@shakkerai/pro-utils';
import { mc } from '@shakkerai/report';
import { createWithEqualityFn } from 'zustand/traditional';

let resolver = null;
let rejecter = null;

/**
 * 下载态
 */
export const useDownloadState = createWithEqualityFn((set) => ({
  downloadModalVisible: false,
  imageUrl: '',

  downloadImageWithConfirm: (imageUrl, imageId) => {
    if (isMainland) {
      return new Promise((resolve, reject) => {
        resolver = resolve;
        rejecter = reject;
        set({
          downloadModalVisible: true,
          imageId,
          imageUrl,
        });
      });
    } else {
      mc('tool.canvas.download', { image_id: imageId, type: 'original' });
      return downloadImage(imageUrl);
    }
  },

  closeDownloadModal: () => {
    set({
      downloadModalVisible: false,
    });
    if (resolver) {
      resolver();
    }

    if (rejecter) {
      rejecter();
    }
  },
}));
